import { render, staticRenderFns } from "./QuestionModalCardCommitOutcome.vue?vue&type=template&id=954558e8&scoped=true&"
import script from "./QuestionModalCardCommitOutcome.vue?vue&type=script&lang=js&"
export * from "./QuestionModalCardCommitOutcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954558e8",
  null
  
)

export default component.exports